import Component from '@glimmer/component';

export default class ClassGroupResultsPrintHeatStartlistComponent extends Component 
{
}